import { createWebHistory, createRouter } from "vue-router";
import Body from '../components/body';

/* Dashboards */
import Default from '../pages/dashboard/default';
import Dashboard from '../pages/dashboard/dashboard';
import Ecommerce from '../pages/dashboard/ecommerce';
import Online from '../pages/dashboard/online'
import Crypto from '../pages/dashboard/crypto'
import Social from '../pages/dashboard/social.vue'
// user
import addUser from '../pages/users/AddUserPage.vue'
import viewUser from '../pages/users/UsersPage.vue'
import deleteUser from '../pages/users/DeletedUsers.vue'
import disableUser from '../pages/users/DisabledUsers.vue'
import UserDetails from '../pages/users/UserDetails.vue'
import Followers from '../pages/users/Followers.vue'
import Following from '../pages/users/Following.vue'
import EditUser from '../pages/users/EditUserPage.vue'
// Brands
import Brands from '../pages/brands/brands.vue';
// Models
import Models from '../pages/models/models.vue';
// Sliders
import AddGroup from '../pages/sliders/AddGroup.vue';
import Groups from '../pages/sliders/Groups.vue';
import GeneralSliders from '../pages/sliders/GeneralSliders.vue';
import LocationSliders from '../pages/sliders/LocationSliders.vue';
import EditGroup from '../pages/sliders/EditGroup.vue';
import LocationSliderClicks from '../pages/sliders/LocationClicks.vue';
import SliderClicks from '../pages/sliders/Clicks.vue';
// Category Types
import CategoryTypes from '../pages/types/categoryTypes.vue';
// Categories
import Categories from '../pages/categories/categories.vue';
// Sub Categories
import Subcategories from '../pages/subcategories/subcategory.vue';
// Attributes
import AddAttribute from '../pages/attributes/AddAttribute.vue';
import ViewAttributes from '../pages/attributes/ViewAttributes.vue';
import ShowAttribute from '../pages/attributes/AttributeDetails.vue';
//Category Attributes
import CategoryAttributes from '../pages/category_attributes/category_attributes.vue';
//Sub Category Attributes
import SubCategoryAttributes from '../pages/sub_category_attributes/sub_category_attributes.vue';
// Vehicles
import AddVehicle from '../pages/vehicles/AddVehicle.vue';
import ExistingVehicles from '../pages/vehicles/ViewVehicles.vue';
import SoldVehicles from '../pages/vehicles/SoldVehicles.vue';
import VehicleDetails from '../pages/vehicles/VehicleDetails.vue';
import EditVehicle from '../pages/vehicles/EditVehicle.vue';
import VehicleClicks from '../pages/vehicles/Clicks.vue';
// Products
import addProduct from '../pages/products/AddProductPage.vue';
import viewProduct from '../pages/products/ViewProducts.vue';
import SoldProducts from '../pages/products/SoldProducts.vue';
import ProductDetails from '../pages/products/ProductDetails.vue';
import editProduct from '../pages/products/EditProducts.vue';
import ProductClicks from '../pages/products/Clicks.vue';
// Accessories
import AddAccessory from '../pages/accessories/AddAccessory.vue';
import ExistingAccessories from '../pages/accessories/ViewAccessories.vue';
import SoldAccessories from '../pages/accessories/SoldAccessories.vue';
import AccessoryDetails from '../pages/accessories/AccessoryDetails.vue';
import EditAccessory from '../pages/accessories/EditAccessory.vue';
import AccessoryClicks from '../pages/accessories/Clicks.vue';
// Reports
import Accessories from '../pages/reports/Accessories.vue';
import Customers from '../pages/reports/Customers.vue';
import Vehicles from '../pages/reports/Vehicles.vue';
import Products from '../pages/reports/Products.vue';
// Notifications
import Notifications from '../pages/notifications/notifications.vue';
// Reported Problems
import ReportedProblems from '../pages/reportedProblems/reportedProblems.vue';
// Settings
import Settings from '../pages/settings/settings.vue';

//Auth
import login from '../auth/login';
import Register from '../auth/register';


const routes = [
  {
    path: '/',
    component: Body,

    children: [
      {
        path: '',
        name: 'defaultRoot',
        component: Dashboard,
        meta: {
          title: ' SLO',
        }
      },

      {
        path: '/brands',
        name: 'brands',
        component: Brands,
        meta: {
          title: 'Brands',
        }
      },

      {
        path: '/models',
        name: 'models',
        component: Models,
        meta: {
          title: 'Models',
        }
      },
      {
        path: '/types',
        name: 'types',
        component: CategoryTypes,
        meta: {
          title: 'Category Types',
        }
      },
      {
        path: '/categories',
        name: 'categories',
        component: Categories,
        meta: {
          title: 'Categories',
        }
      },
      {
        path: '/subcategories',
        name: 'subcategory',
        component: Subcategories,
        meta: {
          title: 'Sub Categories',
        }
      },

      {
        path: '/category_attributes/:id/:cat_id',
        name: 'category_attributes',
        component: CategoryAttributes,
        meta: {
          title: 'Category Attributes',
        }
      },

      {
        path: '/subcategory_attributes/:id/:cat_id/:subcat_id',
        name: 'sub_category_attributes',
        component: SubCategoryAttributes,
        meta: {
          title: 'Sub Category Attributes',
        }
      },

      {
        path: '/notifications',
        name: 'notifications',
        component: Notifications,
        meta: {
          title: 'Notifications',
        }
      },

      {
        path: '/reportedProblems',
        name: 'reportedProblems',
        component: ReportedProblems,
        meta: {
          title: 'Reported Problems',
        }
      },

      {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {
          title: 'Settings',
        }
      },
    ]
  },
  {
    path: '/dashboard',
    component: Body,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          title: 'SLO Dashboard',
        }
      },
    ]
  },
  {
    path: '/users',
    component: Body,
    children: [
      {
        path: "adduser",
        name: "adduser",
        component: addUser,
        meta: {
          title: "Add User",
        },
      },
      {
        path: "viewuser",
        name: "viewuser",
        component: viewUser,
        meta: {
          title: "View User",
        },
      },
      {
        path: "deleteuser",
        name: "deleteuser",
        component: deleteUser,
        meta: {
          title: "Deleted Users",
        },
      },
      {
        path: "disableuser",
        name: "disableuser",
        component: disableUser,
        meta: {
          title: "Disabled Users",
        },
      },
      {
        path: "/users/show/:id",
        name: "users.show",
        meta: { name: "UserDetails" },
        component: UserDetails,
        meta: {
          title: "Users details",
        },
      },
      {
        path: "/users/followers/:id",
        name: "users.followers",
        meta: { name: "Followers" },
        component: Followers,
      },
      {
        path: "/users/following/:id",
        name: "users.following",
        meta: { name: "Following" },
        component: Following,
      },
      {
        path: "/users/edit/:id",
        name: "users.edit",
        meta: { name: "EditUser" },
        component: EditUser,
      },
    ]
  },

  {
    path: '/sliders',
    component: Body,
    children: [
      {
        path: "addgroup",
        name: "addgroup",
        component: AddGroup,
        meta: {
          title: "Add Group",
        },
      },
      {
        path: "groups",
        name: "groups",
        component: Groups,
        meta: {
          title: "Groups",
        },
      },
      {
        path: "gerneralsliders",
        name: "gerneralsliders",
        component: GeneralSliders,
        meta: {
          title: "General Sliders",
        },
      },
      {
        path: "locationsliders",
        name: "locationsliders",
        component: LocationSliders,
        meta: {
          title: "Location Sliders",
        },
      },
      {
        path: "/sliders/groups/edit/:id",
        name: "sliders.groups.edit",
        meta: { name: "EditGroup" },
        component: EditGroup,
      },
      {
        path: "/sliders/general/clicks/:id",
        name: "slider.general.clicks",
        meta: { name: "SliderClicks" },
        component: SliderClicks,
      },
      {
        path: "/sliders/location/clicks/:id",
        name: "slider.location.clicks",
        meta: { name: "LocationSliderClicks" },
        component: LocationSliderClicks,
      },
    ]
  },

  {
    path: '/attributes',
    component: Body,
    children: [
      {
        path: "addattribute",
        name: "addattribute",
        component: AddAttribute,
        meta: {
          title: "Add Attribute",
        },
      },
      {
        path: "viewattribute",
        name: "viewattribute",
        component: ViewAttributes,
        meta: {
          title: "View Attributes",
        },
      },
      {
        path: '/attributes/show/:id',
        name: 'attributes.show',
        meta: { name: 'ShowAttribute' },
        component: ShowAttribute
      },
    ]
  },

  {
    path: '/products',
    component: Body,
    children: [
      {
        path: "addproduct",
        name: "addproduct",
        component: addProduct,
        meta: {
          title: "Add Product",
        },
      },
      {
        path: "products",
        name: "products",
        component: viewProduct,
        meta: {
          title: "View Product",
        },
      },
      {
        path: "soldproducts",
        name: "soldproducts",
        component: SoldProducts,
        meta: {
          title: "Sold Products",
        },
      },
      {
        path: "editproduct/:id",
        name: "editproduct",
        component: editProduct,
        meta: {
          title: "Edit Product",
        },
      },
      {
        path: '/products/show/:id',
        name: 'product.show',
        meta: [{ name: 'ProductDetails' }],
        component: ProductDetails,
        meta: {
          title: "Product Details",
        },
      },
      {
        path: "/products/clicks/:id",
        name: "products.clicks",
        meta: { name: "ProductClicks" },
        component: ProductClicks,
      },


    ]
  },
  {
    path: '/vehicles',
    component: Body,
    children: [
      {
        path: "addvehicle",
        name: "addvehicle",
        component: AddVehicle,
        meta: {
          title: "Add Vehicle",
        },
      },
      {
        path: "existingvehicles",
        name: "existingvehicles",
        component: ExistingVehicles,
        meta: {
          title: "Existing Vehicles",
        },
      },
      {
        path: "soldvehicles",
        name: "soldvehicles",
        component: SoldVehicles,
        meta: {
          title: "Sold Vehicles",
        },
      },
      {
        path: '/vehicles/show/:id',
        name: 'vehicles.show',
        meta: [{ name: 'VehicleDetails' }],
        component: VehicleDetails,
        meta: {
          title: "Vehicle Details",
        },
      },
      {
        path: "/vehicles/edit/:id",
        name: "vehicles.edit",
        meta: { name: "EditVehicle" },
        component: EditVehicle,
      },
      {
        path: "/vehicles/clicks/:id",
        name: "vehicles.clicks",
        meta: { name: "VehicleClicks" },
        component: VehicleClicks,
      },
    ]
  },

  {
    path: '/accessories',
    component: Body,
    children: [
      {
        path: "addaccessory",
        name: "addaccessory",
        component: AddAccessory,
        meta: {
          title: "Add Accessory/ Spare Parts",
        },
      },
      {
        path: "existingaccessories",
        name: "existingaccessories",
        component: ExistingAccessories,
        meta: {
          title: "Existing Accessories & Spare Parts",
        },
      },
      {
        path: "soldaccessories",
        name: "soldaccessories",
        component: SoldAccessories,
        meta: {
          title: "Sold Accessories & Spare Parts",
        },
      },
      {
        path: '/accessories/show/:id',
        name: 'accessories.show',
        meta: [{ name: 'AccessoryDetails' }],
        component: AccessoryDetails,
        meta: {
          title: "Accessory Details",
        },
      },
      {
        path: "/accessories/edit/:id",
        name: "accessories.edit",
        meta: { name: "EditAccessory" },
        component: EditAccessory,
      },
      {
        path: "/accessories/clicks/:id",
        name: "accessories.clicks",
        meta: { name: "AccessoryClicks" },
        component: AccessoryClicks,
      },
    ]
  },

  {
    path: '/reports',
    component: Body,
    children: [
      {
        path: "accessories",
        name: "accessories",
        component: Accessories,
        meta: {
          title: "Accessories",
        },
      },
      {
        path: "customers",
        name: "customers",
        component: Customers,
        meta: {
          title: "Customers",
        },
      },
      {
        path: "vehicles",
        name: "vehicles",
        component: Vehicles,
        meta: {
          title: "Vehicles",
        },
      },
      {
        path: "products",
        name: "products.report",
        component: Products,
        meta: {
          title: "Products",
        },
      },
    ]
  },

  {
    path: '/auth',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: login,
        meta: {
          title: ' Login | SLO',
        }
      },
      {
        path: 'register',
        name: 'register 1',
        component: Register,
        meta: {
          title: ' Register | SLO',
        }
      }
    ]
  },

]
const router = createRouter({
  history: createWebHistory(),
  routes,
})
router.beforeEach((to, from, next) => {
  if (to.meta.title)
    document.title = to.meta.title;
  const path = ['/auth/login', '/auth/register'];
  if (path.includes(to.path) || localStorage.getItem('slo_admin')) {
    return next();
  }
  next('/auth/login');
});
export default router